import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'src/app/shared/models/subscription';
import { DataService } from 'src/app/shared/services/data-service/data.service';

@Component({
  standalone: false,
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
})
export class UserListComponent implements OnInit {
  @Input() selectedEvent: string;
  searchString: string;
  displayOnlySubscribed: boolean;
  subscriptions: Subscription[];
  eventName: string;
  loading: boolean;

  constructor(
    private dataService: DataService,
    private activatedRoute: ActivatedRoute
  ) {
    this.loading = true;
  }

  async ngOnInit(): Promise<void> {
    this.activatedRoute.params.subscribe(async (params: Params) => {
      this.eventName = params.eventName;

      if (this.eventName == undefined || this.eventName == '') {
        // Get all subscriptions
        this.subscriptions = await this.dataService.getAllSubscriptions();
      } else {
        // Get subscription by event
        this.subscriptions = await this.dataService.getSubscriptionByEvent(
          this.eventName
        );
      }
      this.displayOnlySubscribed = true;
      this.loading = false;
    });
  }

  clearSearch() {
    this.searchString = '';
  }

  filter(itemList: Subscription[]): Subscription[] {
    let result: Subscription[] = [];
    if (this.displayOnlySubscribed) {
      result = itemList.filter((i) => i.subscribed == true);
    } else {
      result = itemList;
    }
    return result;
  }
}

